import { render, staticRenderFns } from "./monthQuantityRanking.vue?vue&type=template&id=fa195608&scoped=true&"
import script from "./monthQuantityRanking.vue?vue&type=script&lang=js&"
export * from "./monthQuantityRanking.vue?vue&type=script&lang=js&"
import style0 from "./monthQuantityRanking.vue?vue&type=style&index=0&id=fa195608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa195608",
  null
  
)

export default component.exports